// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.divspeakerform {
  background-color: transparent;
  margin-top: 5px;
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/speakerslist/commonspeakerform/commonspeakerform.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,eAAe;EACf,WAAW;EACX,YAAY;AACd","sourcesContent":[".divspeakerform {\r\n  background-color: transparent;\r\n  margin-top: 5px;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
